<template>
  <div class="mb-5">
    <h2 class="font-weight-bold text-uppercase">Indicar profissional</h2>
    <hr class="linha-amarela" />
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="telefone"> Nome </label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.nome"
            aria-describedby="Nome do profissional a ser indicado"
            placeholder="Digite o nome do profissional"
            @input="ErrorMessages.name = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.name !== null"
          >
            {{ ErrorMessages.name }}
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="telefone"> WhatsApp / Celular </label>
          <input
            type="tel"
            class="form-control"
            v-model="Fields.celular"
            v-mask="['(##) #####-####', '(##) ####-####']"
            aria-describedby="Telefone para cadastro"
            placeholder="Digite o celular ou whatsapp do profissional"
            @input="ErrorMessages.telephone = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.telephone !== null"
          >
            {{ ErrorMessages.telephone }}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-md-6">
        <div class="form-group">
          <label for="id_cidades_atuacao"> Cidade de atuação </label>
          <v-select
            id="id_cidades_atuacao"
            class="select"
            label="nome"
            v-model="Fields.cidade"
            :options="getCities"
            :reduce="(city) => city.id"
            placeholder="Escolha a cidade de atuação do profissional"
            @input="ErrorMessages.city = null"
          >
            <div slot="no-options">Nenhuma cidade foi encontrada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.city !== null"
          >
            {{ ErrorMessages.city }}
          </p>
        </div>
      </div>
      <div class="col-6 col-md-6">
        <div class="form-group">
          <label> Selecione os tipos de serviços </label>
          <v-select
            label="nome"
            v-model="Fields.servicos"
            :options="tipoProfissoes"
            :reduce="(tipoProfissoes) => tipoProfissoes.id"
            placeholder="Escolha os tipos de serviço que o profissional realiza"
            multiple
          >
            <div slot="no-options">Desculpe, ainda não temos esse serviço!</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.services !== null"
          >
            {{ ErrorMessages.services }}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <b-button variant="success" class="ml-auto mr-3" @click="indicate()">
        Indicar
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'IndicateProfessional',
  mixins: [makeToast],
  data() {
    return {
      Fields: {
        nome: null,
        celular: null,
        cidade: null,
        servicos: null,
      },
      ErrorMessages: {
        name: null,
        telephone: null,
        city: null,
        services: null,
      },
    };
  },
  computed: {
    ...mapState(['cidades', 'tipoProfissoes', 'dadosUsuario']),
    ...mapGetters('admin', ['getCities']),
  },
  created() {
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadTipoProfissoes');
    this.$store.dispatch('admin/getCities');
  },
  methods: {
    ...mapActions('affiliate', ['indicateProfessional']),
    indicate() {
      if (this.validate()) {
        this.$store.dispatch('startLoader');

        Object.assign(this.Fields, { userId: this.dadosUsuario.id });
        this.indicateProfessional(this.Fields)
          .then((response) => {
            this.makeToast('Successo!', response.data.message, 'success');

            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => this.$store.dispatch('endLoader'));
      } else {
        this.makeToast(
          'Aviso',
          'Há campos que precisam ser corrigidos',
          'warning'
        );
      }
    },
    validate() {
      let isValid = true;

      if (this.Fields.nome === null || !this.$validate.name(this.Fields.nome)) {
        this.ErrorMessages.name = 'Digite um nome válido';
        isValid = false;
      }

      if (!this.$validate.telephone(this.Fields.celular)) {
        this.ErrorMessages.telephone = 'Telefone inválido';
        isValid = false;
      }

      if (this.Fields.cidade === null) {
        this.ErrorMessages.city = 'Você não selecionou nenhuma cidade';
        isValid = false;
      }

      if (this.Fields.servicos === null) {
        this.ErrorMessages.services = 'Você não selecionou nenhum serviço';
        isValid = false;
      }

      return isValid;
    },
  },
};
</script>

<style scoped>
div.form-group > label {
  font-weight: bold;
}

.select .vs__dropdown-toggle .vs__selected-options .vs__selected {
  overflow-y: visible;
}
</style>
